import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import CssBaseline from '@mui/material/CssBaseline';
import AppRoutes from './appRoutes.js';
const App = () => {
    return (_jsxs(_Fragment, { children: [_jsx(CssBaseline, {}), _jsx(AppRoutes, {})] }));
};
export default App;
